import {
  IsString,
  IsNumber,
  IsIn,
  IsOptional,
  ValidateNested,
  Min,
  Max,
  IsBoolean,
} from 'class-validator';
import { Type } from 'class-transformer';
import { IsColorOrReference } from '@builder4/shared/dto/styles/validators/IsColorOrReference';
import { IsRgbaOrReference } from '@builder4/shared/dto/styles/validators/IsRgbaOrReference';
import {
  VisibilityStateDto,
  PositionAnchorsStateDto,
  ShadowSettingsDto,
} from '@builder4/shared/dto/craft/props/shared';
import { IsTRBLNumberCoords } from '@builder4/shared/dto/craft/validators/IsTRBLNumberCoords';
import { GradientDto, RgbaDto } from '@builder4/shared/dto/styles';

const POSITION_VALUES = ['relative', 'absolute', 'fixed', 'sticky'] as const;
const ICON_STYLE_VALUES = ['solid', 'regular'] as const;

export class IconBreakpointPropsDto {
  @IsOptional()
  @IsString()
  width?: string;

  @IsOptional()
  @IsString()
  height?: string;

  @IsOptional()
  @IsTRBLNumberCoords()
  padding?: [number, number, number, number];

  @IsOptional()
  @IsTRBLNumberCoords()
  margin?: [number, number, number, number];

  @IsOptional()
  @IsTRBLNumberCoords()
  borderRadius?: [number, number, number, number];

  @IsOptional()
  @IsIn([...POSITION_VALUES])
  position?: 'relative' | 'absolute' | 'fixed' | 'sticky';

  @IsOptional()
  @ValidateNested()
  @Type(() => PositionAnchorsStateDto)
  positionAnchorsState?: PositionAnchorsStateDto;

  @IsOptional()
  @IsString()
  left?: string;

  @IsOptional()
  @IsString()
  right?: string;

  @IsOptional()
  @IsString()
  top?: string;

  @IsOptional()
  @IsString()
  bottom?: string;

  @IsOptional()
  @IsNumber()
  @Min(-1)
  @Max(100)
  zIndex?: number;
}

export class IconPropsDto {
  @IsOptional()
  @IsString()
  iconName?: string;

  @IsOptional()
  @IsIn([...ICON_STYLE_VALUES])
  iconStyle?: 'solid' | 'regular';

  @IsOptional()
  @IsRgbaOrReference()
  color?: RgbaDto | string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  opacity?: number;

  @IsOptional()
  @IsString()
  width?: string;

  @IsOptional()
  @IsString()
  height?: string;

  @IsOptional()
  @IsNumber()
  aspectRatio?: number;

  @IsOptional()
  @IsBoolean()
  aspectRatioLock?: boolean;

  @IsOptional()
  @IsTRBLNumberCoords()
  padding?: [number, number, number, number];

  @IsOptional()
  @IsTRBLNumberCoords()
  margin?: [number, number, number, number];

  @IsOptional()
  @IsTRBLNumberCoords()
  borderRadius?: [number, number, number, number];

  @IsOptional()
  @IsColorOrReference()
  backgroundColor?: RgbaDto | GradientDto | string;

  @IsOptional()
  @ValidateNested()
  @Type(() => GradientDto)
  bgGradient?: GradientDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => RgbaDto)
  bgSolid?: RgbaDto;

  @IsOptional()
  @IsRgbaOrReference()
  borderColor?: RgbaDto | string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  borderWidth?: number;

  @IsOptional()
  @IsIn(['none', 'drop'])
  fieldShadowType?: 'none' | 'drop';

  @IsOptional()
  @ValidateNested()
  @Type(() => ShadowSettingsDto)
  fieldShadowSettings?: ShadowSettingsDto;

  @IsOptional()
  @IsIn([...POSITION_VALUES])
  position?: 'relative' | 'absolute' | 'fixed' | 'sticky';

  @IsOptional()
  @IsString()
  top?: string;

  @IsOptional()
  @IsString()
  left?: string;

  @IsOptional()
  @IsString()
  right?: string;

  @IsOptional()
  @IsString()
  bottom?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => PositionAnchorsStateDto)
  positionAnchorsState?: PositionAnchorsStateDto;

  @IsOptional()
  @IsNumber()
  @Min(-1)
  @Max(100)
  zIndex?: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => VisibilityStateDto)
  visibility?: VisibilityStateDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => IconBreakpointPropsDto)
  tablet?: IconBreakpointPropsDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => IconBreakpointPropsDto)
  mobile?: IconBreakpointPropsDto;
}
